import { SessionExpiredModalStyle } from './types';

export const sessionExpiredModalStyles: SessionExpiredModalStyle = {
  dialogWrapper: {
    zIndex: 1400,
    '& .MuiDialog-paper': {
      maxWidth: {
        xs: 'unset !important',
        sm: '432px !important',
      },
      minHeight: 'unset !important',
      height: 'fit-content',
      width: 'auto',
    },
  },
  content: {
    marginTop: '0',
  },
  heading: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '28px',
    marginLeft: '8px',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: { xs: '0', sm: '8px' },
  },
  midContentContainer: {
    width: { sm: '384px' },
  },
  buttonGap: {
    marginRight: '16px',
    '& .MuiButton-endIcon': {
      margin: '0px',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
};
